const en_translations = {}

export default en_translations
